var _path, _g, _path2, _g2, _path3, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgePlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 123,
    viewBox: "0 0 237 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6385 17.458C46.8196 14.7646 50.487 13.7819 53.7226 15.024L97.7445 31.9224C100.98 33.1644 103.048 36.3487 102.867 39.8097L100.399 86.8989C100.217 90.36 97.828 93.3106 94.4803 94.2077L48.9331 106.412C45.5854 107.309 42.0408 105.948 40.1532 103.042L14.4714 63.4951C12.5838 60.5885 12.7825 56.7969 14.9636 54.1035L44.6385 17.458Z",
    fill: "url(#paint0_linear_76_20558)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_76_20558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7764 51.8317C45.5029 50.8111 46.1662 49.7467 47.2577 49.4542L64.9252 44.7202C67.8573 43.9345 70.8298 45.52 71.5644 48.2614C72.2989 51.0028 70.5174 53.8621 67.5853 54.6478L49.9178 59.3817C48.8262 59.6742 47.7197 59.084 47.4462 58.0634L45.7764 51.8317ZM54.7123 79.3777C53.9111 79.5924 53.0988 79.1592 52.898 78.41L50.0029 67.6052C49.2683 64.8638 51.0499 62.0045 53.982 61.2188C56.9142 60.4332 59.8867 62.0186 60.6212 64.76L63.5164 75.5649C63.7171 76.314 63.2303 77.0954 62.429 77.3101L54.7123 79.3777ZM63.2249 62.7568C62.8579 63.0456 63.0111 63.5968 63.4749 63.6558L69.8811 64.47C72.3374 64.7822 74.4109 62.6013 73.8056 60.3422C73.1939 58.0594 70.26 57.2204 68.2954 58.7664L63.2249 62.7568Z",
    fill: "#12D8F2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.298 6.4164C117.102 4.37925 120.898 4.37926 123.702 6.41641L161.851 34.1327C164.654 36.1699 165.828 39.7808 164.757 43.077L150.185 87.923C149.114 91.2192 146.043 93.4509 142.577 93.4509H95.4231C91.9573 93.4509 88.8856 91.2192 87.8146 87.923L73.2433 43.077C72.1723 39.7808 73.3456 36.1699 76.1495 34.1327L114.298 6.4164Z",
    fill: "url(#paint1_linear_76_20558)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_76_20558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.5 39.9132C106.5 38.8566 107.416 38.0001 108.546 38.0001H126.837C129.872 38.0001 132.333 40.3009 132.333 43.139C132.333 45.9771 129.872 48.2779 126.837 48.2779H108.546C107.416 48.2779 106.5 47.4214 106.5 46.3648V39.9132ZM108.002 68.8335C107.172 68.8335 106.5 68.2047 106.5 67.4292V56.2432C106.5 53.405 108.961 51.1043 111.996 51.1043C115.032 51.1043 117.493 53.405 117.493 56.2432V67.4292C117.493 68.2047 116.82 68.8335 115.991 68.8335H108.002ZM120.526 54.9821C120.097 55.1661 120.102 55.7382 120.535 55.9151L126.512 58.3596C128.804 59.2969 131.371 57.727 131.371 55.3882C131.371 53.0249 128.755 51.4551 126.457 52.44L120.526 54.9821Z",
    fill: "#2294EA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.752 15.0239C185.987 13.7819 189.655 14.7645 191.836 17.458L221.511 54.1034C223.692 56.7969 223.891 60.5884 222.003 63.4951L196.321 103.042C194.434 105.948 190.889 107.309 187.541 106.412L141.994 94.2076C138.646 93.3106 136.257 90.36 136.076 86.8989L133.608 39.8097C133.426 36.3486 135.494 33.1644 138.73 31.9223L182.752 15.0239Z",
    fill: "url(#paint2_linear_76_20558)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_76_20558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.55 45.3611C166.823 44.3405 167.93 43.7503 169.021 44.0428L186.689 48.7768C189.621 49.5624 191.403 52.4217 190.668 55.1631C189.933 57.9046 186.961 59.49 184.029 58.7043L166.361 53.9704C165.27 53.6779 164.607 52.6134 164.88 51.5929L166.55 45.3611ZM160.515 73.6846C159.714 73.4699 159.227 72.6886 159.428 71.9395L162.323 61.1346C163.058 58.3932 166.03 56.8078 168.962 57.5934C171.895 58.3791 173.676 61.2384 172.942 63.9798L170.046 74.7846C169.846 75.5338 169.033 75.967 168.232 75.7523L160.515 73.6846ZM176.198 63.5468C175.736 63.6134 175.593 64.1674 175.965 64.4503L181.106 68.3585C183.077 69.8571 185.963 69.0051 186.569 66.746C187.18 64.4632 185.059 62.2696 182.584 62.6263L176.198 63.5468Z",
    fill: "#3B47FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_76_20558",
    x: 45.2812,
    y: 43.2976,
    width: 32.9336,
    height: 40.4689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_76_20558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_76_20558",
    x: 106.5,
    y: 38.0001,
    width: 25.833,
    height: 34.8334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_76_20558"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_76_20558",
    x: 159.064,
    y: 43.5132,
    width: 32.9336,
    height: 40.4689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_76_20558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_20558",
    x1: 99.3696,
    y1: 32.9024,
    x2: 24.2756,
    y2: 81.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01DFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229637,
    stopColor: "#6AF5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529331,
    stopColor: "#D2FFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711591,
    stopColor: "#B4FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_20558",
    x1: 163.167,
    y1: 35.5,
    x2: 78.1667,
    y2: 62.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0191FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229637,
    stopColor: "#6ABEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529331,
    stopColor: "#D2ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711591,
    stopColor: "#B4DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_20558",
    x1: 222.428,
    y1: 55.7647,
    x2: 133.315,
    y2: 59.9256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3139FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229637,
    stopColor: "#6A8AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529331,
    stopColor: "#D2DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711591,
    stopColor: "#B6B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3139FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgePlans);
export default __webpack_public_path__ + "static/media/badgePlans.21f68103823bfced306ccebcb9e27c03.svg";
export { ForwardRef as ReactComponent };